import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  DateRange,
  extractDateRange,
  extractDefaultStoreId,
  extractNumber,
  HxReportService,
  isoDate,
  ReceivablesPayablesModel,
  StoreBasicModel,
  toRouterQueryParams
} from 'hx-services';
import { ActivatedRoute, Router } from '@angular/router';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForOf, NgIf } from '@angular/common';
import { HxDateRangeSelectComponent, HxLoaderComponent, HxStoreSelectComponent } from 'hx-component';
import { SuppliersSearchComponent } from '@manager-app/components/suppliers-search/suppliers-search.component';

@Component({
  selector: 'app-receivables-payables',
  templateUrl: './receivables-payables.component.html',
  imports: [
    FormsModule,
    HxDateRangeSelectComponent,
    HxLoaderComponent,
    HxStoreSelectComponent,
    NgIf,
    TranslocoPipe,
    SuppliersSearchComponent,
    NgForOf,
  ],
  styleUrls: ['./receivables-payables.component.css']
})
export class ReceivablesPayablesComponent {
  params: {
    storeId?: number,
    date?: DateRange,
    supplierId?: number,
  } = {};
  isLoading = {
    list: false,
  };
  list?: ReceivablesPayablesModel[] = [];

  private readonly reportService = inject(HxReportService);
  private readonly aRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly toastr = inject(HcToastrService);
  private readonly tr = inject(TranslocoService);

  constructor() {
    this.aRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe(async paramMap => {
      this.params.date = extractDateRange('date', paramMap) ?? {from: isoDate(new Date()), to: isoDate(new Date())};
      this.params.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      this.params.supplierId = extractNumber('supplierId', paramMap);
      if (this.params.storeId) {
        this.load();
      }
    });
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  onStoreChanged(store?: StoreBasicModel | StoreBasicModel[]) {
    if (Array.isArray(store)) {
      return;
    }
    this.navigate();
  }

  resetFilter() {
    this.params.date = {from: isoDate(new Date()), to: isoDate(new Date())};
    this.params.supplierId = undefined;
    this.navigate();
  }

  private async load() {
    this.list = [];
    this.isLoading.list = true;
    try {
      this.list = await this.reportService.getReceivablesPayables({ fromDate: this.params.date.from, toDate: this.params.date.to, storeId: this.params.storeId, supplierId: this.params.supplierId });
    } finally {
      this.isLoading.list = false;
    }
  }
}
